/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_Stat_1Inputs */

const en_landing_guide_stat_1 = /** @type {(inputs: Landing_Guide_Stat_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2K`)
};

const zh_landing_guide_stat_1 = /** @type {(inputs: Landing_Guide_Stat_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2K`)
};

/**
* | output |
* | --- |
* | "2K" |
*
* @param {Landing_Guide_Stat_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_stat_1 = /** @type {((inputs?: Landing_Guide_Stat_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_Stat_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_stat_1(inputs)
	return zh_landing_guide_stat_1(inputs)
});
export { landing_guide_stat_1 as "landing.guide.stat_1" }